import {
  Dialog,
  DialogBody,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTrigger,
  useDialogController,
} from '@ff-it/ui';
import { type ReactElement } from 'react';
import type { TaskList, ListTask, TaskResponse } from '../types';
import { Form, Submit, useSubmitHandler } from '@ff-it/form';
import { toast } from 'react-toastify';
import { TaskForm } from './TaskForm';
import type { EmbeddedUser } from 'modules/core/types';
import type { KeyedMutator } from 'swr';
import { AddButton } from 'components';
import { createDialog } from './styles.css';
import { FeaturedIcon } from 'components/Icon';

type DialogFormProps = {
  url: string;
  assigneeOptions: EmbeddedUser[];
  onTaskListUpdate: (taskList: TaskList) => void;
  mutate: KeyedMutator<ListTask[]>;
};

const initialValues = {
  name: '',
  status: 'PENDING',
  content: null,
  start_date: null,
  due_date: null,
  assignees: [],
};

function DialogForm({ url, assigneeOptions, onTaskListUpdate, mutate }: DialogFormProps): ReactElement {
  const dialog = useDialogController();
  const onSubmit = useSubmitHandler(
    { url, method: 'POST' },
    {
      onSuccess: (response: TaskResponse) => {
        mutate((items) => [response.task, ...(items || [])]);
        onTaskListUpdate(response.task_list);
        dialog.setOpen(false);
        toast.success('Task has been created.', { autoClose: 3000 });
      },
    },
  );
  return (
    <Form onSubmit={onSubmit} initialValues={initialValues} display="contents" autoComplete="off">
      <DialogHeader title="Add task">
        <FeaturedIcon icon="circle-check" ml="auto" />
      </DialogHeader>
      <DialogBody>
        <TaskForm assigneeOptions={assigneeOptions} />
      </DialogBody>
      <DialogFooter mt="auto">
        <Submit />
        <DialogClose className="ml-auto" />
      </DialogFooter>
    </Form>
  );
}

export function AddTaskDialog(props: DialogFormProps): ReactElement {
  return (
    <Dialog>
      <DialogTrigger>
        <AddButton variant="primary" ml="auto">
          Add task
        </AddButton>
      </DialogTrigger>
      <DialogContent testId="create-task" right overflow="hidden" className={createDialog}>
        <DialogForm {...props} />
      </DialogContent>
    </Dialog>
  );
}
